import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MissionCard = ({ title, description, icon }) => {
    return (
        <div className="col-md-4 mb-4">
            <div className="mission-card text-center">
                <div className="mission-card-icon">
                    <FontAwesomeIcon icon={icon} />
                </div>
                <h4 className="mission-card-title">{title}</h4>
                <p>{description}</p>
            </div>
        </div>
    );
};

MissionCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired
};

export default MissionCard;